/* istanbul ignore file */
import { AssignmentTypeLabels } from '../assignmentService';
import { ButtonsSelectInput, ButtonsSelectInputProps } from 'framework/form';

const AssignmentTypeInput = (props: ButtonsSelectInputProps) => {
  return (
    <ButtonsSelectInput
      {...props}
      options={Object.entries(AssignmentTypeLabels).map(entry => {
        const [value, label] = entry;

        return {
          label,
          value,
        };
      })}
    />
  );
};

export default AssignmentTypeInput;
